export default "\n\n\n<router-outlet></router-outlet>\n\n\n\n"